// Section 19: Mild winter. 8% per season, Winter bias. For the season it strikes: warmth need
// 0.6x, illness 0.8x. No choice. Constants: config.events['mild-winter'].
import type { Config } from '../../config';
import {
  effectDelta,
  effectParamModifiers,
  eventEntry,
  eventTurn,
} from '../../core/content-helpers';
import { defineEvent } from '../../core/registry';

export function mildWinter(config: Config) {
  const c = config.events['mild-winter'];
  return defineEvent({
    id: 'mild-winter',
    label: 'Mild winter',
    section: 'S19',
    baseWeight: c.baseChance,
    seasons: ['winter'],
    foreshadow: null,
    ledgerTag: null,
    weight: () => c.baseChance,
    text: () => eventEntry('mild-winter', { warmth: c.warmthMul, illness: c.illnessMul }),
    apply: (ctx) => [
      effectDelta('mild-winter', 'mild', eventTurn(ctx) + 1, 1, {
        warmthMul: c.warmthMul,
        illnessMul: c.illnessMul,
      }),
    ],
    choices: [],
    modifierTargets: ['demand', 'illnessRisk'],
    modifiers: effectParamModifiers,
  });
}
